import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';
import { BASE_URL, FETCH_COIN, FETCH_COIN_LOG, M_POST } from '@/utils/api';

@Module({ name: 'coin' })
export default class Coin extends VuexModule {
  @Action({ rawError: true })
  async FetchCoinReport(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_COIN,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch coin report failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch coin report failed');
    }
  }

  @Action({ rawError: true })
  async FetchCoinLog(user: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + FETCH_COIN_LOG,
        data: user,
        method: M_POST
      });

      assertOk(data, 'Fetch coin log failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch coin log failed');
    }
  }
}
